import { sortNumber } from '../../utils/sort/sortNumber';
import { sortNumberOrString } from '../../utils/sort/sortNumberOrString';
import { sortNumberWithPrefix } from '../../utils/sort/sortNumberWithPrefix';
import { sortString } from '../../utils/sort/sortString';
import { OrderType } from '../schemas';
import { DataDai } from './types';

export const sortDai = (
  dataDai: DataDai,
  order: OrderType,
  sort: string
): DataDai => {
  if (!dataDai) {
    return dataDai;
  }

  const sortIndex = dataDai.data.columns.findIndex((column) => {
    return column.code === sort;
  });

  const sortType = dataDai.data.columns.find((column) => {
    return column.code === sort;
  });

  if (sortIndex == null || sortType == null) {
    return dataDai;
  }

  const sortedRows = ((): DataDai['data']['rows'] | null => {
    switch (sortType.type) {
      case 'string':
        return sortString(dataDai.data.rows, sortIndex, order);
      case 'number':
        return sortNumber(dataDai.data.rows, sortIndex, order);
      case 'numberWithPrefix':
        return sortNumberWithPrefix(dataDai.data.rows, sortIndex, order);
      case 'numberOrString':
        return sortNumberOrString(dataDai.data.rows, sortIndex, order);
      default:
        return null;
    }
  })();

  if (sortedRows === null) {
    return dataDai;
  }

  return {
    ...dataDai,
    data: {
      ...dataDai.data,
      rows: sortedRows,
    },
  };
};
